import { render } from "./PatrimonioEstatistica.vue?vue&type=template&id=471b9310&scoped=true"
import script from "./PatrimonioEstatistica.vue?vue&type=script&lang=js"
export * from "./PatrimonioEstatistica.vue?vue&type=script&lang=js"

import "./PatrimonioEstatistica.vue?vue&type=style&index=0&id=471b9310&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471b9310"]])

export default __exports__